import { http } from '../util/http';

export default class VehicleStatsService {
	static getStats() {
		return http.get(`/analytics/vehicle-stats`);
	}
}
